var _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#D9622A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7872_285084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9971 12.0278C13.341 12.0278 11.9941 13.3705 11.9941 15.0215C11.9941 15.565 12.2387 16.1494 12.2487 16.1739C12.3275 16.3605 12.4833 16.6511 12.5958 16.8209L14.6546 19.9308C14.7388 20.0584 14.8636 20.1315 14.9966 20.1315C15.1296 20.1315 15.2544 20.0584 15.3387 19.9313L17.3979 16.8214C17.5104 16.6511 17.6661 16.361 17.7449 16.1743C17.755 16.1498 17.9995 15.5654 17.9995 15.0219C17.9995 13.3714 16.6532 12.0278 14.9971 12.0278Z",
    fill: "#D9622A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9968 13.4368C14.12 13.4368 13.4072 14.1478 13.4072 15.0215C13.4072 15.8951 14.1205 16.6061 14.9968 16.6061C15.8732 16.6061 16.5864 15.8951 16.5864 15.0215C16.5864 14.1478 15.8732 13.4368 14.9968 13.4368ZM14.9968 16.2542C14.315 16.2542 13.7602 15.7012 13.7602 15.0215C13.7602 14.3417 14.315 13.7887 14.9968 13.7887C15.6787 13.7887 16.2334 14.3417 16.2334 15.0215C16.2334 15.7012 15.6787 16.2542 14.9968 16.2542Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 20.6897,
    width: 2.97755,
    height: 0.439866,
    rx: 0.219933,
    fill: "#D9622A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7872_285084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3095 8C8.03582 8 7 9.03262 7 10.3024C7 10.7204 7.18811 11.1698 7.19581 11.1887C7.25642 11.3322 7.37622 11.5557 7.46274 11.6863L9.04607 14.078C9.11088 14.1762 9.20686 14.2324 9.30915 14.2324C9.41143 14.2324 9.50741 14.1762 9.57222 14.0784L11.1559 11.6866C11.2424 11.5557 11.3622 11.3325 11.4228 11.189C11.4305 11.1701 11.6186 10.7207 11.6186 10.3027C11.6186 9.03332 10.5832 8 9.3095 8Z",
    fill: "#D9622A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30944 9.08362C8.63513 9.08362 8.08691 9.63048 8.08691 10.3024C8.08691 10.9743 8.63548 11.5211 9.30944 11.5211C9.98341 11.5211 10.532 10.9743 10.532 10.3024C10.532 9.63048 9.98341 9.08362 9.30944 9.08362ZM9.30944 11.2505C8.78505 11.2505 8.35839 10.8251 8.35839 10.3024C8.35839 9.7796 8.78505 9.35426 9.30944 9.35426C9.83384 9.35426 10.2605 9.7796 10.2605 10.3024C10.2605 10.8251 9.83384 11.2505 9.30944 11.2505Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.15723,
    y: 14.6616,
    width: 2.28998,
    height: 0.338292,
    rx: 0.169146,
    fill: "#D9622A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7872_285084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6493 8C19.3757 8 18.3398 9.03262 18.3398 10.3024C18.3398 10.7204 18.528 11.1698 18.5357 11.1887C18.5963 11.3322 18.7161 11.5557 18.8026 11.6863L20.3859 14.078C20.4507 14.1762 20.5467 14.2324 20.649 14.2324C20.7513 14.2324 20.8473 14.1762 20.9121 14.0784L22.4957 11.6866C22.5823 11.5557 22.7021 11.3325 22.7627 11.189C22.7704 11.1701 22.9585 10.7207 22.9585 10.3027C22.9585 9.03332 21.923 8 20.6493 8Z",
    fill: "#D9622A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6493 9.08362C19.975 9.08362 19.4268 9.63048 19.4268 10.3024C19.4268 10.9743 19.9753 11.5211 20.6493 11.5211C21.3233 11.5211 21.8718 10.9743 21.8718 10.3024C21.8718 9.63048 21.3233 9.08362 20.6493 9.08362ZM20.6493 11.2505C20.1249 11.2505 19.6982 10.8251 19.6982 10.3024C19.6982 9.7796 20.1249 9.35426 20.6493 9.35426C21.1737 9.35426 21.6003 9.7796 21.6003 10.3024C21.6003 10.8251 21.1737 11.2505 20.6493 11.2505Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4971,
    y: 14.6616,
    width: 2.28998,
    height: 0.338292,
    rx: 0.169146,
    fill: "#D9622A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7872_285084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.00586,
    height: 8.10368,
    fill: "white",
    transform: "translate(11.9941 12.0278)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7872_285084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.61899,
    height: 6.23238,
    fill: "white",
    transform: "translate(7 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7872_285084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.61899,
    height: 6.23238,
    fill: "white",
    transform: "translate(18.3398 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegions);
export default __webpack_public_path__ + "static/media/regions.bca0f499c1e4ec894ac171d84d741004.svg";
export { ForwardRef as ReactComponent };